export const TransfersEndpoints = {
  getTransfersList: 'getTransfersList',
  getTransfersListInf: 'getTransfersListInf',
  createTransfer: 'createTransfer',
  getTransferById: 'getTransferById',
} as const;

export const TransfersTags = {
  transfers: 'transfers',
} as const;

export const BASE_TRANSFERS_URL = '/v1/products/transfers';
